<template>
  <div v-if="page">
    <h2>{{ $t("packages.allpackages.title") }}</h2>
    <packages-table
      :isDividends="false"
      :viewer="page.viewer.username"
      :header="activeHeaders"
      :packages="
        page.viewer.downlinePackages
          .filter((p) =&gt; p.isPackageActive)
          .map((p) =&gt; this.moreInfo(p))
      "
      class="mb-3"
      :table-title="$t('packages.loyaltytable-title')"
    />
    <freedom-program-table
      :viewer="page.viewer.username"
      :table-title="$t('fp.freedom-program-table-title')"
      :header="freedomActiveHeaders"
      :programs="downlineFreedomProgramSorted"
      class="mb-3"
    />
    <!-- :header="activeHeaders" :packages="page.viewer.downlinePackages.filter(p =&gt; p.isPackageActive).map(p =&gt; this.moreInfo(p))" :table-title="$t('Active packages')" -->
    <packages-table
      :isDividends="true"
      :viewer="page.viewer.username"
      :header="expiredHeaders"
      :packages="
        page.viewer.downlinePackages
          .filter((p) =&gt; !p.isPackageActive && p.sellAt && p.sellBackStatus &lt; 2)
          .map((p) =&gt; this.transformDataExpired(p))
      "
      :table-title="$t('packages.dividendstable-title')"
      class="mb-3"
    />
    <exclusives-table
      :allUsers="true"
      :packages="page.downlineEra"
      :tableTitle="$t('resort.table-title')"
      :header="exclusivesHeaders"
    ></exclusives-table>
    <packages-history-table
      :viewer="page.viewer.username"
      class="my-3"
      :table-title="$t('packages.historytable-title')"
      :packages="
        page.viewer.downlinePackages
          .filter(
            (p) =&gt; !p.isPackageActive && (!p.sellAt || p.sellBackStatus &gt; 1)
          )
          .map((p) =&gt; this.transformDataExpired(p))
      "
      :header="historyHeaders"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PackagesTable from "@/components/Packages/PackagesTable.vue";
import ExclusivesTable from "@/components/Packages/ExclusivesTable";
import FreedomProgramTable from "@/components/Packages/FreedomProgramTable.vue";
import PackagesHistoryTable from "@/components/Packages/PackagesHistoryTable";
import gql from "graphql-tag";
export default {
  name: "AllPackages",
  components: {
    PackagesTable,
    FreedomProgramTable,
    PackagesHistoryTable,
    ExclusivesTable,
  },
  data() {
    return {
      downlineFreedomProgramSorted: null,
      page: null,
      activeHeaders: [
        {
          value: "user",
          text: this.$i18n.t("packages.loyaltytable-username"),
          sortable: false,
          class: "text-center",
        },
        {
          value: "ID",
          text: this.$i18n.t("packages.loyaltytable-id"),
          sortable: false,
        },
        {
          value: "id",
          text: this.$i18n.t("packages.loyaltytable-activation-date"),
          sortable: false,
          class: "text-center",
        },
        {
          value: "expires",
          text: this.$i18n.t("packages.loyaltytable-expires-date"),
          sortable: false,
        },
        {
          value: "type",
          text: this.$i18n.t("packages.loyaltytable-type"),
          sortable: false,
        },
        {
          value: "filled",
          text: this.$i18n.t("packages.loyaltytable-fresh"),
          sortable: false,
        },
        {
          value: "value",
          text: this.$i18n.t("packages.loyaltytable-value"),
          sortable: false,
        },
      ],
      expiredHeaders: [
        {
          value: "user",
          text: this.$i18n.t("packages.dividendstable-username"),
          sortable: false,
          class: "text-center",
        },
        {
          value: "id",
          text: this.$i18n.t("packages.dividendstable-id"),
          sortable: false,
        },
        {
          value: "expires",
          text: this.$i18n.t("packages.dividendstable-starting-date"),
          sortable: false,
          class: "text-center",
        },
        {
          value: "sellAt",
          text: this.$i18n.t("packages.dividendstable-ending-date"),
          sortable: false,
        },
        {
          value: "type",
          text: this.$i18n.t("packages.dividendstable-type"),
          sortable: false,
        },
        {
          value: "filled",
          text: this.$i18n.t("packages.dividendstable-fresh"),
          sortable: false,
        },
        {
          value: "value",
          text: this.$i18n.t("packages.dividendstable-value"),
          sortable: false,
        },
      ],
      historyHeaders: [
        {
          value: "user",
          text: this.$i18n.t("packages.historytable-username"),
          sortable: false,
          class: "text-center",
        },
        {
          value: "id",
          text: this.$i18n.t("packages.historytable-id"),
          sortable: false,
        },
        {
          value: "startDate",
          text: this.$i18n.t("packages.historytable-start-date-end-date"),
          sortable: false,
          class: "text-center",
        },
        {
          value: "packageId",
          text: this.$i18n.t("packages.historytable-convert-date"),
          sortable: false,
          class: "text-center",
        },
        {
          value: "type",
          text: this.$i18n.t("packages.historytable-type"),
          sortable: false,
        },
        {
          value: "fresh",
          text: this.$i18n.t("packages.historytable-value"),
          sortable: false,
        },
        {
          value: "value",
          text: this.$i18n.t("packages.historytable-status"),
          sortable: false,
        },
      ],
      freedomActiveHeaders: [
        {
          value: "user",
          text: this.$i18n.t("fp.freedom-program-table-username"),
          sortable: false,
          class: "text-center",
        },
        {
          value: "installment",
          text: this.$i18n.t("fp.freedom-program-table-no"),
          sortable: false,
          class: "text-center",
        },
        {
          value: "id",
          text: this.$i18n.t("fp.freedom-program-table-started"),
          sortable: false,
          class: "text-center",
        },
        {
          value: "id",
          text: this.$i18n.t("fp.freedom-program-table-payment-date"),
          sortable: false,
          class: "text-center",
        },
        {
          value: "nextPay",
          text: this.$i18n.t("fp.freedom-program-table-next-pay"),
          sortable: false,
        },
        {
          value: "percentage",
          text: this.$i18n.t("fp.freedom-program-table-percentage"),
          sortable: false,
        },
        {
          value: "program",
          text: this.$i18n.t("fp.freedom-program-table-name"),
          sortable: false,
        },
        {
          value: "value",
          text: this.$i18n.t("fp.freedom-program-table-value"),
          sortable: false,
        },
        {
          value: "total",
          text: this.$i18n.t("fp.freedom-program-table-total"),
          sortable: false,
        },
      ],
      exclusivesHeaders: [
        {
          value: "User",
          text: this.$i18n.t("resort.accessestable-user"),
          sortable: false,
        },
        {
          value: "ID",
          text: this.$i18n.t("resort.accessestable-id"),
          sortable: false,
        },
        {
          value: "startDate",
          text: this.$i18n.t("resort.accessestable-start-date"),
          sortable: false,
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      active: "packages/activePackages",
      activeCount: "packages/activePackagesCount",
      expired: "packages/expiredPackages",
      expiredCount: "packages/expiredPackagessCount",
    }),
  },
  apollo: {
    page: {
      query: gql`
        query {
          viewer {
            id
            username
            downlinePackages {
              id
              isPackageActive
              expiresAt
              upgradedAt
              sellAt
              sellBackStatus
              sellBackDate
              packageName
              noCommission
              totalValueInTokens
              freshValueInTokens
              valueInFiat
              totalValueInFiat
              user {
                id
                username
                viewerLeg
                viewerPath
              }
            }
            downlineFreedomProgram {
              id
              active
              nextPaymentStart
              nextPaymentEnd
              programEnd
              programName
              programFriendlyName
              totalValueInFiat
              totalValueInTokens
              user {
                id
                username
                viewerLeg
                viewerPath
              }
              deposits {
                id
                sequenceNumber
                valueInFiat
                valueInTokens
                paymentDelay
                rewardInstallment
              }
            }
          }
          viewer {
            totals {
              tokens
            }
          }
          viewerIsAdmin
          downlineEra {
            id
            user {
              username
              viewerLeg
            }
          }
        }
      `,
      update: (data) => data,
      result({ data }) {
        if (data) {
          this.$store.commit("user/updateAvailable", {
            tokens: data.viewer.totals.tokens,
          });
          if (data.viewerIsAdmin) {
            this.$store.commit("user/setAdmin");
          }

          this.downlineFreedomProgramSorted =
            data.viewer.downlineFreedomProgram.sort((a, b) =>
              a.nextPaymentStart > b.nextPaymentStart ? 1 : -1
            );
        }
      },
    },
  },
  methods: {
    moreInfo(p) {
      return {
        color:
          p.valueInFiat[0] < 9000000
            ? "primary"
            : p.valueInFiat[0] < 90000000
            ? "success"
            : "dark",
        ...p,
      };
    },
    transformDataExpired(p) {
      return {
        color:
          p.valueInFiat[0] < 19000000
            ? "primary"
            : p.valueInFiat[0] < 900000000
            ? "success"
            : "dark",
        ...p,
      };
    },
  },
};
</script>

<style scoped></style>